import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';

import { selectLegalNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { attachedContentComponent } from '@nodeTypeConfig/helpers/editComponents/attachedContent';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const LEGAL: BuildingBlockNodeConfig = {
  nodeSelector: selectLegalNode,
  information: {
    single: 'Wettekst',
    plural: 'Wettekst',
    ribonIcon: require('../../../../img/buildingBlocks/LEGAL.svg'),
  },

  createDefaults: {
    attachments: [
      {
        type: 'CONTENT',
        name: 'content.html',
        contentType: 'text/html',
      },
    ],
  },
  buildingBlocks: [
    { type: NodeType.PARAGRAPH },
    { type: NodeType.IMAGE_GROUP },
    { type: NodeType.IMAGE },
    { type: NodeType.VIDEO },
  ],
  edit: [
    {
      ...identifierComponent,
      width: 3,
    },
    {
      ...titleComponent,
      width: 9,
    },
    {
      ...attachedContentComponent,
      label: ' ',
    },
  ],
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default LEGAL;
